<app-grid
  stateKey="PurchaseOrderLineReceipts"
  [gridCssClass]="gridCssClass"
  [columnDefs]="columnDefs"
  [rowData]="model$ | async"
  [showDelete]="false"
  [pagination]="false"
></app-grid>
